// 脱敏 加密 信息加密
class EncryptionApi {
  /**
   * 解密日志 vmiService/basicData/saveDecryptLog
   * @param data 查询参数
   * @returns
   */
  saveDecLog(_this,data) {
    return _this.$http({
      url: '/vmiService/basicData/saveDecryptLog',
      method: 'POST',
      data,
    })
  }
 
  /**
   * 解密方法
   * @param data 详情参数
   * @returns
   */
  decrypt(_this,data){
    return _this.$http({
      url: '/base/decrypt',
      method: 'POST',
      headers: {"Content-Type":"application/json"},
      data
    })
  }
}
 
const encryptionApi = new EncryptionApi()
 
export default encryptionApi